import { mdiNoteMultipleOutline } from '@mdi/js'

export default {
  title: 'Bank Question',
  to: 'bank-headmaster',
  icon: mdiNoteMultipleOutline,
  resource: 'BankQuestionHeadMaster',
  action: 'read',
}
